function beforeFileUpload (callSource, file, acceptFileType, size) {
  const acceptFileType_ = acceptFileType === 'excel' ? 'application/vnd.ms-excel' : ''
  const type = file.type
  const isFile = type === acceptFileType_
  const isSizeAllow = file.size / 1024 / 1024 < size
  const isBlankSpace = file.name.indexOf(' ') === -1

  if (!isFile) {
    // callSource.$message.error('只支持格式' + acceptFileType)
    callSource.$message.error('导入文件格式错误!')
  }

  if (!isSizeAllow) {
    callSource.$message.error(`上传文件大小不能超过 ${size}M!`)
  }

  if (!isBlankSpace) {
    callSource.$message.error('文件名不能包含空格!')
  }

  return isFile && isSizeAllow && isBlankSpace
}

function beforeHeadImageUpload (callSource, file, name, fileType, fileSize) {
  const size = fileSize || 0.5

  const isJPGPNG = fileType ? file.type === fileType : file.type === 'image/jpeg' || file.type === 'image/png'
  const isSizeAllow = file.size / 1024 / 1024 < size

  if (!isJPGPNG) {
    const type = fileType || 'jpg、png'
    callSource.$message.error(`上传${name}图片只能是 ${type} 格式!`)
  }
  if (!isSizeAllow) {
    callSource.$message.error(`上传${name}图片大小不能超过 ${size * 1000} kb!`)
  }
  return isJPGPNG && isSizeAllow
}

function handleLoadSuccess (callSource, res, file, key) {
  if (res.success) callSource.ruleForm[key] = res.data.file
  else callSource.$message.error(res.message)
  callSource.share[key] = URL.createObjectURL(file.raw)
}

export default {
  beforeFileUpload,
  beforeHeadImageUpload,
  handleLoadSuccess
}
